import React from "react";
import TextInput from "./TextInput";

type ReadOnlyTextInputProps = {
  value: string;
  labelText: string | undefined;
  containerClassName?: string;
  inputId: string;
};

function ReadOnlyTextInput({
  value,
  labelText,
  containerClassName,
  inputId,
}: ReadOnlyTextInputProps) {
  return (
    <TextInput
      inputId={inputId}
      containerClassName={containerClassName}
      type="text"
      value={value}
      readOnly
      labelText={labelText}
      onChange={() => {}}
    />
  );
}

export default ReadOnlyTextInput;
